import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ScreenDoor} from './ScreenDoor'
import {CloseX} from './CloseX'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'


const boxStyle: React.CSSProperties = {
    height: '240px',
    width: '500px',
    position: 'absolute',
    top: '50%',
    marginTop: '-120px',
    left: '50%',
    marginLeft: '-270px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    borderRadius:'20px',
    '@media (max-width:414px)': {
        width:'350px',
        marginLeft:'-175px',
        left:'45%'
    },
    '@media (max-width:375px)': {
        width:'300px',
        marginLeft:'-150px'
    },
    '@media (max-width:320px)': {
        width:'270px',
        marginLeft:'-155px'
    }
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    height: '30px',
    alignItems: 'center'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    flexGrow: 0,
    fontFamily:'Lulo',
    '@media (max-width:320px)': {
        marginRight:'25px'
    }
}
const dashHdrLine: React.CSSProperties = {
    width:'110px',
    backgroundColor:'#616060',
    height:'3px',
    display:'inline-block',
    marginBottom:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.2em',
    fontSize:'19px',
    fontFamily:'Lulo',
    color:'#616060'
}
const hdrDiv: React.CSSProperties = {
    textAlign:'center',
}
let infoStyle = Object.assign({}, lblStyle, {height: 'auto', marginBottom: '10px', fontSize: '14px', textAlign: 'center',fontFamily:'AveriaSerifRegular'})

const inputStyle: React.CSSProperties = {
    backgroundColor: Tgcc.Styles.inputBackground,
    border: 'none',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '16px',
    flexGrow: 1
}

const submitBtn : React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Lulo',
    color:'white',
    ':hover': {
        border: '1px solid #666',
        cursor: 'pointer'
    }
}

const backBtnStyle: React.CSSProperties = {
    height:'35px',
    cursor:'pointer',
    fontFamily:'Lulo',
    lineHeight:'35px',
    padding:'0px 25px',
    width:'100px',
    textAlign:'center',
    backgroundColor:'#E9E6E6',
    color:'#616060',
    position:'relative',
    top:'57px',
    left:'350px'
}

let fadedButtonStyle = Object.assign( {}, submitBtn, { opacity: 0.5});

class Props extends Tgcc.BaseProps{
    email: string;
}

class _CampusForgotPassword extends React.Component<Props, any> {
    state: any = {
        email: "",
        isWaiting: false
    };

    componentWillMount(){
        this.setState({email: this.props.email});
    }
    
    cancel = () => {
        this.setState({isWaiting: false});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null})
    }

    onSuccess = () => {
        var msg="An email has been dispatched with instructions for creating a new password for your account. The reset link will expire in 24 hours.";
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.MessagePopup, payload: {title: "Password Reset", message: msg}}})
    }
    failedReset = (err: any) => {
        this.setState({isWaiting: false, error: err});
    }

    doReset = () => {
        if(!Tgcc.IsValidEmail(this.state.email)){
            this.setState({error: 'Please enter a valid email address', isWaiting: false});
        }else {
           this.setState({isWaiting: true});
           Request.campusPasswordResetRequest(this.state.email, this.onSuccess, this.failedReset)
        }
    }

    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    emailIsValid = () => {
        return Tgcc.IsValidEmail(this.state.email);
    }

    keyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doReset();
    }
    getForgotPassword(){
        return (
            <div style={hdrDiv}>
                <div style={dashHdrLine}></div>
                <div style={dashText}>FORGOT PASSWORD</div>
                <div style={dashHdrLine}></div>

            </div>
        )
    }

    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div style={submitBtn} onClick={this.doReset} className="campusSubmitForgotBtn">Submit</div>
        btnElement = this.emailIsValid() ? btnElement : <div className="campusSubmitForgotBtn" style={fadedButtonStyle}>Submit</div>

        var errElement = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div/>
        return(
            <ScreenDoor>
                <div style={boxStyle}>
                    {this.getForgotPassword()}
                    {errElement}
                    <div style={rowStyle}>
                        <div style={infoStyle}>Submit your email address to receive a password reset link.</div>
                    </div>
                    <div style={rowStyle}>
                        <div style={lblStyle}>Email</div>
                        <input autoFocus type='text' style={inputStyle}  name='email' onChange={this.emailChanged} onKeyPress={this.keyPressed} value={this.state.email}/>
                    </div>
                    <div onClick={this.cancel} style={backBtnStyle} className="campusForgotBtn">Back</div>
                    {btnElement}
                </div>
            </ScreenDoor>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var CampusForgotPassword = connect(mapStateToProps)(Radium(_CampusForgotPassword));